<template>
  <div class="BrandProfile">
    <div class="well max-w-2xl mx-auto p-0 px-3 py-4">
      <div>
        <img
            :src="brand.logo_url"
            class="spark-profile-photo-xxl mb-4 w-25 inline-block"
            style="float: left; border-radius: 5px !important;"
            :alt="brand.name"
        />
        <div class="w-75 inline-blockp pl-5" style="float: left;">
          <p>{{ brand.name }}</p>
          <p>{{ brand.website }}</p>
          <!--<p>{{ brand.industry }}</p>-->
          <!-- <p class="btn btn-block btn-info"><a :href="`/brands/${brand.id}/message`">Send besked</a></p> -->
          <ChatModal
                v-if="spark.client === 'web'"
                class="inline-block"
                :refresh="refreshChat"
                :thread-id="chatThreadId"
            >
                <template v-slot:default="{ open, loading }">
                    <button
                        type="button"
                        class="btn btn-primary text-lg relative shadow-lg"
                        title="Åbn beskeder"
                        :disabled="loading"
                        :data-init="initializeChat(open)"
                        @click="open"
                    >
                      <p class="btn btn-block btn-info">Send besked</p>
                    </button>
                </template>
            </ChatModal>
        </div>
        <div style="clear: both;" />
      </div>
      <div class="text-white">
        <h3 class="text-white m-0" v-text="brand.name"></h3>
      </div>
      <div v-if="brand.interest_links">
        <h4>Interesse links</h4>
        <ul>
          <li v-for="link in brand.interest_links">{{ link }}</li>
        </ul>
      </div>
      <div>
        <h4>SDG Bio</h4>
        <p style="font-style: italic">Ingen bio</p>
      </div>
      <div>
        <h4>SDG</h4>
        <p style="font-style: italic">Intet valgt</p>
      </div>
      <div>
        <h4>Aktive Kampagner</h4>
        <div v-if="brand.active_campaigns">
          <div v-for="campaign in brand.active_campaigns">{{ campaign }}</div>
        </div>
        <div v-else>
          <p>Ingen aktive kampagner</p>
        </div>
      </div>
      <div>
        <h4>Tidligere Kampagner</h4>
        <div v-if="brand.past_campaigns">
          <div v-for="campaign in brand.past_campaigns">{{ campaign }}</div>
        </div>
        <div v-else>
          <p>Ingen tidligere kampagner</p>
        </div>
      </div>
    </div>

    <PageLoader :loading="loading" />
  </div>
</template>

<style type="text/less" lang="less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';
@import '~dashboard-less/spark/components/Tabs';

.BrandProfile {
  .Tabs(@brand-primary);
}

.BrandProfile .Tabs > li:not(.active) > a {
@apply text-gray-700;
}

.BrandProfile {
  .CoverImage {
    min-height: 150px;
  }

  .BrandProfile__cover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2));

    .RatingStars .star {
      font-size: 30px;
    }
  }
}
</style>
<script type="text/babel">
import CoverImage from 'dashboard-js/components/utilities/CoverImage'
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
//import InfluencerProfileChannelsTab from './InfluencerProfileChannelsTab'
//import InfluencerProfileReviewsTab from 'dashboard-js/components/influencers/InfluencerProfileReviewsTab'
import PageLoader from 'dashboard-js/components/utilities/PageLoader'
import RatingStars from 'dashboard-js/components/reviews/RatingStars'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'
import Tab from 'dashboard-js/components/tabs/Tab'
import TabContent from 'dashboard-js/components/tabs/TabContent'
import TabPanel from 'dashboard-js/components/tabs/TabPanel'
import Tabs from 'dashboard-js/components/tabs/Tabs'
import TextBlock from 'dashboard-js/components/utilities/TextBlock'
import { ReplaySubject } from 'rxjs'
import ChatModal from 'dashboard-js/components/chat/ChatModal'

export default {
  components: {
    TabPanel,
    Tab,
    TabContent,
    Tabs,
    RatingStars,
    CoverImage,
    TextBlock,
    PageLoader,
    ChatModal,
    //InfluencerProfileReviewsTab,
    //InfluencerProfileChannelsTab,
  },

  mixins: [HasLoadingState, RestoreOnPageBack],

  props: ['chatThreadId', 'dataBrand', 'apiUrl', 'platform'],

  data() {
    return {
      brand: {
        activeCampaigns: null,
        pastCampaigns: null,

        ...this.dataBrand,
      },
      initializing: true,
      initializedChat: false,
      refreshChat: new ReplaySubject(1),
    }
  },

  watch: {
        status() {
            // When status change, we might want to lock the conversation.
            this.refreshChat.next()
        },
    },

    methods: {
        initializeChat(open) {
            if (!this.initializedChat && window.location.hash.endsWith('messages')) {
                this.initializedChat = true
                open()
            }
        },
  },

  computed: {
    endpoint() {
      return this.apiUrl ? this.apiUrl : route('api.brand.show', this.dataBrand)
    },
  },

  created() {
    this.onPageVisit(() => {
      axios
          .get(this.endpoint)
          .then(response => Object.assign(this.brand, response.data.data))
          .then(this.finishLoading())
          .then(this.saveState)
    })
  },

  beforeDestroy() {
    this.saveState()
  },
}
</script>
